import * as React from 'react';

import { DegreePlan_LearnerProgressState as LearnerProgressState } from '__generated__/graphql-types';

import { useRetracked } from 'js/lib/retracked';

import { Button, Link } from '@coursera/cds-core';

import type { UseCurriculum_PersonalizedSegmentCourseFragment as SegmentCourse } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';

import _t from 'i18n!nls/degree-home';

type Props = {
  course: SegmentCourse;
};

const GoToCourseButton: React.VFC<Props> = ({ course }) => {
  const track = useRetracked();

  const { segmentCourse, learnerProgress } = course;
  const { courseraCourse, courseCode, courseName } = segmentCourse.course;

  const courseSlug = courseraCourse?.slug || '';

  const isInProgressOrCompleted =
    learnerProgress.state === LearnerProgressState.InProgress ||
    learnerProgress.state === LearnerProgressState.Completed;

  const showGoToCourseButton = isInProgressOrCompleted && courseSlug;

  if (!showGoToCourseButton) {
    return null;
  }

  const handleGoToCourse = () => {
    track({
      action: 'click',
      trackingName: 'go_to_course',
      trackingData: { courseSlug, courseName, courseCode },
    });
  };

  return (
    <Button
      component={Link}
      href={`/learn/${courseSlug}/home/welcome`}
      target="_blank"
      variant="ghost"
      size="small"
      onClick={handleGoToCourse}
    >
      {_t('Go to course')}
    </Button>
  );
};

export default GoToCourseButton;
